import { DayTypeType } from './day.interface';
import { Festival } from './festival.interface';

export interface SendListExport {
  id?: number;
  festival_id: number;
  uuid: string;
  filename: string;
  festival?: Festival;
}

export interface SendListExportParams {
  festival_id: number;
  date?: string;
  day_type?: DayTypeType;
}
